// TEST-only 18+ stand-in for the ID check on a free first session.
// On only when REACT_APP_ADULT_SELF_ATTEST=true (fly.test.toml). Live keeps the real ID check.
export const adultSelfAttestOn = () => process.env.REACT_APP_ADULT_SELF_ATTEST === 'true';
export const isAdultSelfAttestedUser = user => {
  if (!adultSelfAttestOn()) return false;
  const p = user?.attributes?.profile || {};
  return !!((p.protectedData || {}).adultSelfAttestedAt || (p.privateData || {}).adultSelfAttestedAt);
};
